import { useState } from "react";
import ModalBase from "../../../global/ModalBase"
import { FEscalaStyle } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { closeModalEscalasVuelo } from "../../../ducks/proveedorTerrestreDuck";
import HeaderModal from "../../../global/headerModal";
import { AppBar, Box, Grid, Tab, Tabs } from "@material-ui/core";
import TEscalasVuelos from "./TEscalasVuelos";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    )
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const FEscalasVuelos = () => {
    const classes = FEscalaStyle();
    const dispatch = useDispatch();
    const [value, setValue] = useState(0)
    const { openEscalasVuelo, vueloTarget } = useSelector(store => store.proveedorTerrestre);

    const handleClose = () => {
        dispatch(closeModalEscalasVuelo())
    }

    const handleChange = (event, newValue) => {
        if (vueloTarget?.EsRedondo || newValue === 0) {
            setValue(newValue);
        }
    };

    return (
        <div>
            <ModalBase classes={classes} open={openEscalasVuelo} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo={`Escalas `}
                />
                <Grid container className={classes.containerSpacing}>
                    <AppBar position="static">
                        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                            <Tab label="Escalas vuelo ida" {...a11yProps(0)} />
                            {vueloTarget?.EsRedondo && <Tab label="Escalas vuelo regreso" {...a11yProps(1)} />}
                        </Tabs>
                    </AppBar>
                    <TabPanel value={value} index={0} className={classes.containerSpacingItem}>
                        <TEscalasVuelos tipo="ida" />
                    </TabPanel>
                    {vueloTarget?.EsRedondo && (
                        <TabPanel value={value} index={1} className={classes.containerSpacingItem}>
                            <TEscalasVuelos tipo="regreso" />
                        </TabPanel>  
                    )}
                </Grid>
            </ModalBase>
        </div>
    )
}



export default FEscalasVuelos;